import { render, staticRenderFns } from "./attachment.vue?vue&type=template&id=b5bde38a&scoped=true"
import script from "./attachment.vue?vue&type=script&lang=js"
export * from "./attachment.vue?vue&type=script&lang=js"
import style0 from "./attachment.vue?vue&type=style&index=0&id=b5bde38a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bde38a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5bde38a')) {
      api.createRecord('b5bde38a', component.options)
    } else {
      api.reload('b5bde38a', component.options)
    }
    module.hot.accept("./attachment.vue?vue&type=template&id=b5bde38a&scoped=true", function () {
      api.rerender('b5bde38a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/attachment/attachment.vue"
export default component.exports